import { ConnectedAppCard } from "fleet/controller/application/connected-large-card";
import PropTypes from "prop-types";
import React from "react";
import { NavLoader } from "ui/loader";
import { Page } from "view/layout/page";

class AppList extends React.PureComponent {
  static get propTypes() {
    return {
      apps: PropTypes.array.isRequired,
      storesLoaded: PropTypes.bool.isRequired,
      title: PropTypes.string.isRequired,
    };
  }

  _renderAppCards() {
    const { apps } = this.props;

    if (!apps.length) {
      return <span>There are no applications available.</span>;
    }

    const cards = apps.map((app) => (
      <ConnectedAppCard key={app.id} app={app} />
    ));
    return cards;
  }

  _renderView() {
    const { storesLoaded } = this.props;

    if (!storesLoaded) {
      return <NavLoader.Proxy />;
    }

    return <div className="app-cards-container">{this._renderAppCards()}</div>;
  }

  render() {
    const { title } = this.props;
    const view = this._renderView();
    return <Page title={title}>{view}</Page>;
  }
}

export { AppList };
